module.exports = __webpack_public_path__ + "img/flower_leaf_22.396cb704.png";